// extracted by mini-css-extract-plugin
export default {"pillStyles":"vIouRkYN4shaPQzXRSCC","pillTextStyles":"Ywq8XEpSZHW02mrU4rWj","marginRight":"jBdYjSRPAwC3LqaPuezA","marginRightLargeCount":"htFiwj80IJggBrlJTPoG"};